import reduceReducers from 'reduce-reducers';

import { utils, store as commonStore } from '@febos-io/common';
import { store as healthCommonStore } from '@febos-io/health-common';
import { store as authStore } from '@febos-io/auth';
import { theme } from '@febos-io/design';

import appReducer from '../store/reducer';
import state from '../store/state';

export default function configureReducers(initialState = state) {
  return reduceReducers(
    initialState,
    utils.combineReducers({
      app: appReducer,
      common: commonStore.reducer,
      healthCommon: healthCommonStore.reducer,
      auth: authStore.reducer,
      ...theme.store.reducers
    })
  );
}
